export default function SoftTag () {

    return(
    <div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base  px-3 py-1 rounded-xl inline-block mx-1 mb-1">
            Git
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base  px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        Git Hub
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base  px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        Miro
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base  px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        Figma
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base  px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        Trello Kanban
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base  px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        Excalidraw
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base  px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        MS 365
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base  px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        Agile Methodology
        </div>
        <div className="text-[#64ffda] bg-[#64ffda]/10 m-auto text-sm md:sm lg:text-base  px-3 py-1 rounded-xl inline-block mx-1 mb-1">
        UX/UI Design
        </div>
    </div>
    )
}